import Table from '../../components/Table';
import {TabContainer} from './Tab1';

const Tab2 = () => {
  const data = [
    {day: '3月17日', reward: '开放转生、秘籍、战技'},
    {day: '3月21日', reward: '开放挂饰、面具、开放破军披风'},
    {day: '3月29日', reward: '开放名侠'}
  ];

  const data3 = [
    {day: '3月17日', reward: '凡品秘籍影石、天赋丹'},
    {day: '3月21日', reward: '绝世矿物颜料、黑石'},
    {day: '3月24日', reward: '星玉、星辰矿'},
    {day: '3月29日', reward: '名侠简录、符文宝匣'},
    {day: '4月13日', reward: '镇派灵丹、镇派灵药'}
  ];

  return (
    <TabContainer>
      <p className="bold">阶段解封</p>
      <p>
        <span className="bold">活动区服</span>：
        <span>龙盘紫霄（2010区新服）</span>
      </p>
      <p>
        <span className="bold">活动时间</span>：3月17日、 3月21日、3月24日、 3月29日、4月13日
      </p>
      <p className="bold">活动内容：</p>
      <p>
      （1）为保证各位大侠畅快体验“上线即战”，本组新服将控制部分系统开放时间，一段时间内控制大侠间的实力差，各重点系统功能开放时间如下；
      </p>
      <Table
        columns={[
          {title: '日期', key: 'day', width: '30%'},
          {title: '开放新内容', key: 'reward', width: '70%'}
        ]}
        data={data}
      />
      <p>
        （2）与此同时，
        <span>阶段开放当天，新服将有阶段性出现的BOSS前往武林各地挑战各路大侠</span>
        。与帮会成员齐心协力击退BOSS后，根据各帮会对BOSS造成的伤害情况，帮会可以获得阶段BOSS奖励，同时世界拍卖亦将刷新一批珍贵宝物。各BOSS出现时间及可能获得奖励如下；
      </p>
      <Table
        columns={[
          {title: '日期', key: 'day', width: '30%'},
          {title: 'BOSS宝物', key: 'reward', width: '70%'}
        ]}
        data={data3}
      />
      <p>
      （3）击退BOSS后，需由帮会管理（长老或帮主）点击BOSS留下的宝物进行领奖以获得帮会奖励，参与挑战的帮会成员可参与boss掉落的奖励拍卖。
      </p>
    </TabContainer>
  );
};

export default Tab2;
